import React, { memo } from 'react'
import { Space, Tooltip } from 'antd'
import { ArrowRightOutlined } from '@ant-design/icons'
import { TimeLineContentWrapper, TimeLineContentHeaderWrapper } from '../../../styles/styles'
import { ActivityStage } from '../../../types/types'
import { Avatar } from '../../../../../../ui/Avatar'
import Stage from './stage/stage'
import TimelineItemHeader from '../activity-timeline-item-header/activity-timeline-item-header'
import { TimelineItemProps } from '../activity-timeline-Item'

type ActivityTimelineStageType = Omit<TimelineItemProps, 'data'>

interface ActivityTimelineStageProps extends ActivityTimelineStageType {
  className?: string
  data?: ActivityStage
}

const ActivityTimelineStage: React.FC<ActivityTimelineStageProps> = memo(
  (props: ActivityTimelineStageProps) => {
    const { date, user, data } = props
    return (
      <TimeLineContentWrapper>
        <TimeLineContentHeaderWrapper>
          <TimelineItemHeader date={date} title={'Стадия изменена'} />
          <Space>
            <Space>
              <Avatar src={user?.icon} alt={user?.name} />
              <Tooltip placement="top" title="Автор">
                <span>{user?.name}</span>
              </Tooltip>
            </Space>
          </Space>
        </TimeLineContentHeaderWrapper>
        <Space>
          <Stage style={data?.stage_from?.style}>{data?.stage_from?.name}</Stage>
          <ArrowRightOutlined style={{ color: '#b1bac3' }} />
          <Stage style={data?.stage_to?.style}>{data?.stage_to?.name}</Stage>
        </Space>
      </TimeLineContentWrapper>
    )
  },
)

ActivityTimelineStage.displayName = 'ActivityTimelineStage'
export default ActivityTimelineStage
